import api, { apiAction, apiActionWithRoute } from '../../../api'

export const getIngredient = entityId => apiActionWithRoute(api.getIngredient)(entityId)()
export const addIngredient = item => apiAction(api.addIngredient)(item)
export const updateIngredient = (entityId, item) => apiActionWithRoute(api.updateIngredient)(entityId)(item)
export const deleteIngredient =  entityId => apiActionWithRoute(api.deleteIngredient)(entityId)()
